import { render, staticRenderFns } from "./ProgressReportList.vue?vue&type=template&id=6baf498f&scoped=true&"
import script from "./ProgressReportList.vue?vue&type=script&lang=js&"
export * from "./ProgressReportList.vue?vue&type=script&lang=js&"
import style0 from "./ProgressReportList.vue?vue&type=style&index=0&id=6baf498f&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6baf498f",
  null
  
)

export default component.exports